// extracted by mini-css-extract-plugin
export default {"errorContainer":"MensajeError_errorContainer__08Wkv","errores":"MensajeError_errores__rcmun"};